import { cn } from '../../lib/utils'
import { Typography, type TypographyProps } from '../typography'

export function Label({ className, children, ...props }: TypographyProps) {
  return (
    <Typography
      variant='label'
      data-slot='label'
      className={cn(className)}
      {...props}
    >
      {children}
    </Typography>
  )
}
